import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=309c79ec&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=309c79ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309c79ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309c79ec')) {
      api.createRecord('309c79ec', component.options)
    } else {
      api.reload('309c79ec', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=309c79ec&scoped=true&", function () {
      api.rerender('309c79ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YBRTxCw5rpGm/JS/teamMember.vue"
export default component.exports